import { createTheme, ThemeOptions, PaletteOptions } from '@mui/material/styles';

// Base theme options that will be used as defaults
const defaultThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: 'rgb(0,0,0)', // Default black
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: '#f44336',
    },
    background: {
      default: '#fae159', // Default yellow
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
};

// Function to create a theme, merging defaults with tenant-specific overrides
const createCustomTheme = (tenantMetadatas?: { [key: string]: any }) => {
  const overrides: ThemeOptions = {};

  if (tenantMetadatas) {
    const paletteOverrides: PaletteOptions = {};

    const primaryMain = tenantMetadatas['theme.palette.primary.main'];
    const primaryContrastText = tenantMetadatas['theme.palette.primary.contrastText'];
    const backgroundDefault = tenantMetadatas['theme.palette.background.default'];

    if (primaryMain || primaryContrastText) {
      paletteOverrides.primary = {};
      if (primaryMain) {
        paletteOverrides.primary.main = primaryMain as string;
      }
      if (primaryContrastText) {
        paletteOverrides.primary.contrastText = primaryContrastText as string;
      }
    }

    if (backgroundDefault) {
      paletteOverrides.background = {
        default: backgroundDefault as string,
      };
    }
    
    if (Object.keys(paletteOverrides).length > 0) {
      overrides.palette = paletteOverrides;
    }
  }

  return createTheme(defaultThemeOptions, overrides);
};

export default createCustomTheme;

export const defaultMuiTheme = createTheme(defaultThemeOptions);
